import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { WalletProvider } from "./lib/wallet/provider.js";
import "./styles.css";

const container = document.getElementById("root");
if (container === null) throw new Error("the terminal has no mount point");

createRoot(container).render(
  <StrictMode>
    <WalletProvider>
      <App />
    </WalletProvider>
  </StrictMode>,
);
